import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import Flogo from "../../Assets/Projects/fontana-logo1.png";
import ecosystemImg from "../../Assets/Projects/ecosystem.png";
import luminaLogo from "../../Assets/Projects/luminar-logo.png";
import CeruleanImg from "../../Assets/Projects/cerulean.png";


function Ecosystem() {
  const presaleUrl = "https://docs.google.com/forms/d/e/1FAIpQLSfnRbDnm61M8kAUOQF9uSZMWZyspBXUNvKbA-t6Ml9ARog3_A/viewform?usp=sharing&ouid=103015240996433302632";

  return (
    <main id="ecosystem" className="project-section">
      <Particle />

      <Container className="py-5">
        {/* Hero */}
        <section className=" mb-5">
          <h1 className="fw-bold fs-2 text-accent">Sovereign Engine: Govern. Trade. Reward.</h1>
          <img src={ecosystemImg} alt="Ecosystem" className="img-fluid w-100 my-3 rounded-3 d-block" />
          <p className="lead text-muted mt-3">75% of ecosystem activity flows back to the community — earned, distributed, and compounding protocol strength.</p>
        </section>

        {/* Token Triple-Helix */}
        <section className="mb-5">
          <Row className="g-4">
            <Col md={4}>
              <div className="p-4 bg-fontana-dark text-white rounded h-100 d-flex flex-column align-items-center text-center">
               <img src={Flogo} alt="Fontana logo" className="ecos-token-logo mb-3" />
                <h5 className="text-accent fw-bold">$FONTANA <small className="text-light">(Engine)</small></h5>
                <p className="mb-0 flex-grow-1">The governance gateway and driver of ecosystem growth — proposal power, protocol incentives and long-term alignment for builders and stewards.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-4 bg-fontana-dark text-white rounded h-100 d-flex flex-column align-items-center text-center">
                <img src={luminaLogo} alt="Lumina logo" className="ecos-token-logo mb-3" />
                <h5 className="text-accent fw-bold">$LUMINA <small className="text-light">(Utility)</small></h5>
                <p className="mb-0 flex-grow-1">High-velocity fuel for CrickSet T20 and MUKO phygital rewards — spend where engagement and velocity create utility value.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-4 bg-fontana-dark text-white rounded h-100 d-flex flex-column align-items-center text-center">
                <img src={CeruleanImg} alt="Cerulean logo" className="ecos-token-logo  mb-3" />
                <h5 className="text-accent fw-bold">$CERULEAN <small className="text-light">(Storage)</small></h5>
                <p className="mb-0 flex-grow-1">The unbuyable value standard — harvested exclusively via genuine ‘Dust’ activity, preserving capital and protocol solidity.</p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Dust Mechanic */}
        <section className="mb-5">
          <h3 className="fw-semibold">The Dust Mechanic</h3>
          <div className="text-muted">
            <ul className="list-unstyled">
              <li className="mb-3">
                <strong>Sovereign Governance:</strong> Dust measures your contribution and grants you voting power — decisions are driven by the most active participants, not the largest wallets.
              </li>
              <li>
                <strong>CST Materialization:</strong> Dust can crystallize into CST (Cerulean Sovereign Token); as you reach participation milestones your Dust converts into the unbuyable standard held in the Cerulean Vault.
              </li>
            </ul>
          </div>
        </section>

        {/* Utility Pillars */}
        <section className="mb-5">
          <Row>
            <Col md={6}>
              <h4 className="fw-bold">Lumeria Metaverse</h4>
              <p className="text-muted">Lumeria is the Metaverse frontier where your T20 predictions, NBA strategy, and Soccer loyalty transform into a digital legacy. It is a world powered by $LUMINA, secured by the Cerulean Vault, and built by you. In Lumeria, Fontana does not sell you the gear. We provide the world; you provide the value. Every item—from athlete equipment in CrickSet to digital skins in 
                the Lumeria districts—is crafted, owned, and traded by the players. We provide the blueprint; you build the empire.
              </p>
            </Col>
            <Col md={6}>
              <h4 className="fw-bold">Realityverse</h4>
              <p className="text-muted">We don't believe value should stay trapped behind a screen. 
                The Realityverse is the Fontana bridge to the real world. Through our unique RVP system, your  activity in ecosystem 
                earns you more than just digital assets—it earns you real world participation, and access to exclusive global events.

One Engine. Total Reality.</p>
            </Col>
          </Row>
        </section>


        {/* The Vault */}
        <section className="mb-5">
          <h3 className="fw-semibold">The Cerulean Vault</h3>
          <p className="text-muted">The asset-backed foundation of the ecosystem. $CERULEAN anchors supply, secures rewards and underwrites protocol stability — minted from real activity, not market speculation.</p>
        </section>

  

        {/* CTA */}
        <section className="text-center py-4">
          <Button as="a" href={presaleUrl} target="_blank" rel="noopener noreferrer" variant="light" className="fw-bold text-accent py-2 px-4">Secure Your Standing in Round 1</Button>
        </section>
      </Container>
    </main>
  );
}

export default Ecosystem;
